import { create } from "zustand";
import type { Language } from "../types";
import {
  getLanguage
} from "../utils/language";

type LanguageState = {
  readonly isChangingLanguage: boolean
  readonly languageCookie?: Language
  readonly language?: Language
}

export type LanguageActions = {
  readonly setIsChangingLanguage: (isChangingLanguage: boolean) => void
  readonly setLanguage: (language: Language, languageCookie?: Language) => void
}

const initialLangaugeState: LanguageState = {
  isChangingLanguage: false,
  language: undefined,
  languageCookie: getLanguage()
};

export const useLanguageStore = create<LanguageState & LanguageActions>((set) => ({
  ...initialLangaugeState,
  setIsChangingLanguage: (isChangingLanguage: boolean) => {
    set({ isChangingLanguage });
  },
  setLanguage: (language, languageCookie?: Language) => {
    set({ language });
    languageCookie && set({ languageCookie });
    const lang = document.querySelector("html");
    lang?.setAttribute("lang", language.id);
  }
}));
